import React from "react";
import { useErrorIconSize } from "../Icons/ErrorIconSize";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { ErrorGlobeOffIcon } from "../Icons/ErrorGlobeOffIcon";

export const UnsupportedBrowserVersionPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    
    return (
        <ErrorPageWrapper
            icon={<ErrorGlobeOffIcon size={iconSize}/>}
            content={<label>Dein <b>Browser</b> ist leider nicht auf dem aktuellen Stand.</label>}
        />
    );
}